




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class LabelComponent extends Vue {
  @Prop({ default: true, type: Boolean }) public readonly isBold!: boolean;
  @Prop(String) public readonly text!: string;
}
